/*
document.addEventListener("DOMContentLoaded", _ => {
    if (document.querySelector(".carousel")) {
        console.log("init carousel")

    }

})
*/